export default {
    forgotYourPassword: 'หากลืมรหัสผ่าน',
    textResetYourPassword: 'เราจะส่งอีเมลเพื่อเปลี่ยนรหัสผ่านถึงคุณกรุณายืนยันอีเมลที่ลงทะเบียนด้านล่าง',
    emailAddress: 'อีเมล',
    enterYourEmailAddress: 'ระบุอีเมล',
    sendEmail: 'ส่ง',
    emailSent: 'ส่งอีเมลสำเร็จ',
    returnToLogIn: 'เข้าสู่ระบบ',
    resetPasswordLink: 'ลิงก์เปลี่ยนรหัสผ่านถูกส่งไปที่',
    notThisEmail: 'ไม่ใช่อีเมลนี้ ?',
    emailAddressIsRequired: 'กรุณากรอกอีเมล',
    emailAddressIsNotValid: 'อีเมลไม่ถูกต้อง'
}
